import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { KeyRound, BellRing } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// "Password dimenticata?": chiede l'email e avvisa l'amministratore, che reimposta la password e te la comunica. Nessuna email.
// La risposta del server e' sempre la stessa, che l'indirizzo esista o no.
export const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Inserisci la tua email');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      if (res.ok) {
        setSent(true);
      } else {
        const data = await res.json().catch(() => ({}));
        toast.error(data.detail || 'Richiesta non riuscita, riprova');
      }
    } catch (err) {
      toast.error('Errore di connessione');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-2">
            {sent ? <BellRing className="h-6 w-6 text-green-600" /> : <KeyRound className="h-6 w-6 text-slate-700" />}
          </div>
          <CardTitle>{sent ? 'Richiesta inviata' : 'Hai dimenticato la password?'}</CardTitle>
          <CardDescription>
            {sent
              ? 'Se l’indirizzo è registrato, abbiamo avvisato l’amministratore: ti comunicherà una nuova password. Non arriva nessuna email.'
              : 'Scrivi l’email con cui entri nel portale: avviseremo l’amministratore, che ti comunicherà una nuova password.'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground">
                Quando l’amministratore ti avrà comunicato la nuova password, entra con quella: al primo accesso ne sceglierai una tua.
                Basta una sola richiesta, non serve ripeterla.
              </p>
              <Button className="w-full" onClick={() => navigate('/login')} data-testid="forgot-back-login">
                Torna al login
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="forgot-email">Email</Label>
                <Input
                  id="forgot-email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="nome@esempio.it"
                  data-testid="forgot-email-input"
                  required
                />
              </div>
              <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
                {loading ? 'Invio in corso…' : 'Avvisa l’amministratore'}
              </Button>
              <button
                type="button"
                className="w-full text-sm text-muted-foreground hover:text-foreground"
                onClick={() => navigate('/login')}
              >
                Torna al login
              </button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ForgotPassword;
